export function groupBy(dataset, getKey, transform) {
    return dataset.reduce((grouped, data) => {
        const key = getKey(data)
        if(!grouped[key]){
            grouped[key] = transform(null, key, data)
        }
        grouped[key] = transform(grouped[key], key, data)
        return grouped
    }, {});
}